import ECharts from 'echarts';

const warningData = [
  { 
    name: '1',
    value: 20
  },
  { 
    name: '2',
    value: 25
  },
  { 
    name: '3',
    value: 40
  },
  { 
    name: '4',
    value: 42
  },
  { 
    name: '5',
    value: 55
  },
  { 
    name: '6',
    value: 68
  },
  { 
    name: '7',
    value: 76
  },
  { 
    name: '8',
    value: 88
  },
  { 
    name: '9',
    value: 90
  },
  { 
    name: '10',
    value: 97
  },
  { 
    name: '11',
    value: 115
  },
  { 
    name: '12',
    value: 131
  }
];

const dateName = [];// 名称
const dataValue = []; //数值

//for循环chartsJSON
for (let i = 0; i < warningData.length; i++) {
  dateName.push(warningData[i].name);
  dataValue.push(warningData[i].value);
}
export default {
  grid: {
    left: '2%',
    right: '5%',
    bottom: '5%',
    top: '10%',
    containLabel: true,
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      lineStyle: {
        color: '#ddd'
      }
    },
    formatter: '{b0}月: {c0}元',
    backgroundColor: 'rgba(255,255,255,1)',
    padding: [5, 10],
    textStyle: {
      color: '#7588E4',
    },
    extraCssText: 'box-shadow: 0 0 5px rgba(0,0,0,0.3)'
  },
  xAxis: {
    type: 'category',
    data: dateName,
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '#ffffff'
      }
    },
  },
  yAxis: {
    splitLine: {
      show: false,
      color: 'red',
    },
    axisLine: {
      lineStyle: {
        color: '#ffffff',
      }
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: false,
      textStyle: {
        fontSize: 10,
        color: '#ffffff',
      }
    }
  },
  series: [{
    name: '销售总额',
    animation: true,
    // animationDuration: '3000',
    type: 'line',
    smooth: true,
    symbol: 'circle',
    symbolSize: 2,
    data: dataValue,
    areaStyle: {
      normal: {
        color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: 'rgba(205,52,42, 0.5)'
        }, {
          offset: 0.8,
          color: 'rgba(235,235,21, 0)'
        }], false),
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10
      },
    },
    itemStyle: {
      normal: {
        color: '#1C6EFB'
      }
    },
  }]
};
